import type { DialogueContent } from '../../interactions/dialogue';
import type { SceneDefinition } from '../scene.types';

export const galerieDialogues: DialogueContent[] = [
  {
    id: 'galerie.entry',
    lines: [
      'La grande allée. Elle continue à droite. Elle continue toujours à droite, en fait.',
    ],
    character: 'La boutique',
    once: true,
  },
];

/**
 * Salle panoramique : un mur d'étagères qui se parcourt de gauche à droite.
 * Le décor est une tuile répétée, la scène est donc bien plus large que haute
 * et se déplace au doigt, à la souris ou aux flèches.
 *
 * Géométrie relevée sur la tuile : 12 colonnes de 4,90 % de large, 5 rangées de
 * 15,20 % de haut ; les trois premières rangées sont utilisées.
 */
export const galerieScene: SceneDefinition = {
  id: 'galerie',
  title: 'La Grande Allée',
  // Le décor de chaque étagère et de chaque passage est posé en CSS par le
  // composant : la scène n'a pas d'image de fond unique.
  background: '',
  entryDialogueId: 'galerie.entry',
  layers: [],
  aisle: {
    perLevel: 3,
    mobilePerLevel: 2,
    maxProducts: 24,
    hideUnavailable: true,
    exit: { target: 'reserve', label: 'Quitter l’allée' },
    collections: [
      { handle: 'produits-mastication', label: 'Mastication' },
      { handle: 'friandises-dentaires', label: 'Friandises' },
      { handle: 'jouets-chiens', label: 'Jouets' },
      { handle: 'tapis-de-lechage-chiens', label: 'Tapis de léchage' },
      { handle: 'packs', label: 'Packs' },
      { handle: 'nouveautes', label: 'Nouveautés' },
    ],
  },
  hotspots: [],
};
